import { ReportTemplate } from './ReportTemplate'

export const AggregationType = {
	Day: 'gb_day',
	Month: 'gb_month',
}

const AggregationTypeInverse = {}
Object.entries(ReportTemplate.AggregationType)
	.forEach(([key, value]) => {
		AggregationTypeInverse[value] = key
	})

export class ReportTemplateStreetsDetailed extends ReportTemplate {
	static AggregationType = AggregationType

	constructor(...args) {
		super(...args)
		this.set('type', ReportTemplate.Type.StreetsDetailed)
	}

	getFieldList() {
		return this._getSetting('columns')
	}

	setFieldList(list) {
		return this._setSetting('columns', list)
	}

	getStreetList() {
		return this._getSetting('streets')
	}

	setStreetList(streets) {
		return this._setSetting('streets', streets)
	}

	setAggregationType(type) {
		if (!(type in AggregationTypeInverse)) {
			throw new TypeError(`ReportTemplateStreetsDetailed.setAggregationType: invalid type: ${type}`)
		}
		this._setSetting('groupBy', type)
		return this
	}

	getAggregationType() {
		return this._getSetting('groupBy')
	}

	static testProperties(properties) {
		return properties.type === ReportTemplate.Type.StreetsDetailed
	}
}
